import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  CanActivateDraftSectionView,
  CanActivateSectionView,
  SectionResolver,
} from './resolver';
import { SectionViewComponent } from './section-view.component';

const sectionRoutes: Routes = [
  {
    path: 'view',
    pathMatch: 'full',
    canActivate: [CanActivateSectionView],
    component: SectionViewComponent,
    resolve: {
      section: SectionResolver,
    },
  },
  {
    path: 'view_draft',
    pathMatch: 'full',
    canActivate: [CanActivateDraftSectionView],
    component: SectionViewComponent,
    data: { isDraft: true },
    resolve: {
      section: SectionResolver,
    },
  },
];

export const sectionViewRouting: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(sectionRoutes);
